import { Link } from 'react-router-dom'

import { Button } from '../button'

interface Props {
  items: Array<{ label: string; href: string; isActive: boolean; reloadDocument?: boolean }>
}

export function SubMenuTabs({ items }: Props) {
  return (
    <div className="-mb-px flex w-full items-center">
      {items.map(({ label, href, isActive, reloadDocument }) => (
        <Button
          key={href}
          as={Link}
          to={href}
          reloadDocument={reloadDocument}
          theme="tab"
          rounding="none"
          active={isActive}
          size="medium"
        >
          {label}
        </Button>
      ))}
    </div>
  )
}
